// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"228":"252f366e","255":"7d0bf13e","445":"1bfc9850","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"228":"fd5f631ffe725f306045","255":"60e7a68753329cc8ea9d","445":"f6e6ce8cdd10ff14d70c","691":"eb5e3fcb6bcca85b88c7"}[chunkId] + ".js";
};